module.exports = __webpack_public_path__ + "img/michelle-circle.734b145a.png";